/**
 * @author Andrés Camilo Ferreira Rodríguez
 * @Copyright (c) Infotrack. All rights reserved.
 */
import { useProveedor } from '@infotrack/presentacion-componentes/proveedorEstado';
import Texto from '@infotrack/presentacion-componentes/texto';
import { TipoFormulario } from '@infotrack/presentacion-transversales/interfacesComunes';
import { useInputState } from '@infotrack/presentacion-utilitarios/hooks';
import {
    manejadorDialogoGlobal,
    manejadorIndicadorCargaGlobal,
} from '@infotrack/presentacion-utilitarios/manejadoresComponentes';
import IBodegasTiposPropiedades from 'Infotrack@Modelos/smartStock/bodegasTiposPropiedades/entidades/bodegasTiposPropiedades';
import { IEstadoGlobal } from 'Infotrack@Reductores/interfacesReductores';
import React from 'react';
import { connect } from 'react-redux';
import BodegasTiposPropiedadesCM from '../controladorModelo/bodegasTiposPropiedadesCM';
import { IFormularioBodegasTiposPropiedadesCVProps } from '../interfaces';
import { acciones, IEstadoBodegasTiposPropiedades } from '../reductorBodegasTiposPropiedades';
import FormularioBodegasTiposPropiedadesVista from '../vista/formularioBodegasTiposPropiedadesVista';

const estadoInicial: IBodegasTiposPropiedades = {
    EmpresaId: '',
    BodegaTipoPropiedadDescripcion: '',
    Propiedad: '',
    Estado: 1,
    AgenciaId: '',
};
const bodegasTiposPropiedadesCM = new BodegasTiposPropiedadesCM();

const FormularioBodegasTiposPropiedadesCV: React.FunctionComponent<IFormularioBodegasTiposPropiedadesCVProps> = ({
    IdEmpresa,
    IdAgencia,
}) => {
    const [{ estadoFormulario, tipoFormulario, entidadBodegasTiposPropiedades }, dispatch] = useProveedor<
        IEstadoBodegasTiposPropiedades
    >();
    const { alCambiarValor, setValor, reiniciar, valor } = useInputState<IBodegasTiposPropiedades>(estadoInicial);

    React.useEffect(() => {
        if (entidadBodegasTiposPropiedades && tipoFormulario !== TipoFormulario.Creacion) {
            setValor(entidadBodegasTiposPropiedades);
        } else {
            reiniciar();
        }
    }, [entidadBodegasTiposPropiedades]);

    const cerrarFormulario = () => {
        dispatch({ type: acciones.CAMBIAR_ESTADO_FORMULARIO, payload: null });
    };
    const confirmarCreacionEdicionBodegasTiposPropiedades = () => {
        if (bodegasTiposPropiedadesCM.validarEntidad(valor)) {
            manejadorDialogoGlobal({
                accionCancelar: () => manejadorDialogoGlobal({ estado: false }),
                accionConfirmar: crearEditarBodegasTiposPropiedades,
                estado: true,
                mensaje: (
                    <Texto
                        id={
                            tipoFormulario === TipoFormulario.Creacion
                                ? 'alerta.confirmacionCreacion'
                                : 'alerta.confirmacionEdicion'
                        }
                    />
                ),
                mostrarCancelar: true,
                tipoDialogo: 'Advertencia',
                titulo: <Texto id="titulo.advertencia" />,
            });
        }
    };

    const crearEditarBodegasTiposPropiedades = () => {
        manejadorDialogoGlobal({ estado: false });
        manejadorIndicadorCargaGlobal(true);
        if (tipoFormulario === TipoFormulario.Creacion) {
            bodegasTiposPropiedadesCM
                .crearBodegasTiposPropiedades({
                    ...valor,
                    EmpresaId: IdEmpresa,
                    AgenciaId: IdAgencia,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        } else {
            bodegasTiposPropiedadesCM
                .editarBodegasTiposPropiedades({
                    ...valor,
                    EmpresaId: IdEmpresa,
                    AgenciaId: IdAgencia,
                    Estado: valor.Estado === true || valor.Estado === 1 ? 1 : 0,
                })
                .then(() => {
                    cerrarFormulario();
                    manejadorIndicadorCargaGlobal(false);
                    dispatch({ type: acciones.RECARGAR_TABLA });
                });
        }
    };

    return (
        <FormularioBodegasTiposPropiedadesVista
            accionCrearEditar={confirmarCreacionEdicionBodegasTiposPropiedades}
            cambiarInfoFomulario={alCambiarValor}
            bodegasTiposPropiedades={valor}
            cerrarFormulario={cerrarFormulario}
            estadoFormulario={estadoFormulario}
            tipoFormulario={tipoFormulario}
        />
    );
};

const estadoAPropiedades = ({
    estadoAutenticacion: { usuarioInformacion, agenciaActual },
}: IEstadoGlobal): IFormularioBodegasTiposPropiedadesCVProps => ({
    IdEmpresa: usuarioInformacion!.IdEmpresa,
    IdAgencia: agenciaActual!.IdAgencia,
});

export default connect<IFormularioBodegasTiposPropiedadesCVProps, null, any, IEstadoGlobal>(
    estadoAPropiedades,
    null
)(FormularioBodegasTiposPropiedadesCV);
